import Markdown from 'markdown-to-jsx';

import { MarkdownOptions } from '../pdf-rendering';

export const PdfMarkdown: React.FC<{ markdown: string }> = ({ markdown }) => {
  // custom logic to handle underlines because they come through as HTML elements
  // markdown-to-jsx doesn't wrap them in a paragraph because of this and we lose
  // the text styling if they are standalone (not a part of another element). So,
  // we wrap them in a paragraph ourselves.
  const processedMarkdown = markdown.startsWith('<u>')
    ? `<p>${markdown}</p>`
    : markdown;

  return <Markdown options={MarkdownOptions}>{processedMarkdown}</Markdown>;
};
